var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.875C30.0061 34.875 34.875 30.0061 34.875 24C34.875 17.9939 30.0061 13.125 24 13.125C17.9939 13.125 13.125 17.9939 13.125 24C13.125 30.0061 17.9939 34.875 24 34.875Z",
    fill: "#D5FF7D",
    stroke: "black",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.75V13.125M34.875 24H38.25M9.75 24H13.125M24 34.875V38.25",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8125 27.9375C26.0907 27.9375 27.9375 26.0907 27.9375 23.8125C27.9375 21.5343 26.0907 19.6875 23.8125 19.6875C21.5343 19.6875 19.6875 21.5343 19.6875 23.8125C19.6875 26.0907 21.5343 27.9375 23.8125 27.9375Z",
    fill: "#D5FF7D",
    stroke: "black",
    strokeWidth: 1.5625
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L35.625 35.625",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGps);
export default __webpack_public_path__ + "static/media/noGps.7d957c5088ee441457cfab9c3cba6c86.svg";
export { ForwardRef as ReactComponent };